
<div *ngIf="!loader">
  <div mat-dialog-title class="d-flex justify-content-between align-items-center pt-2">
    <div class="prese_heading">
    <h2 class="m-0">Edit service </h2>
    </div>
    <div class="prese_button">
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
    </div>
  </div>
  <mat-dialog-content>

    <div class="ad_hesig">
    <label for="" class="gth_heding" >Service provider type</label>
    <!-- <mat-form-field appearance="outline"> -->
        <mat-radio-group aria-label="Select an option">
            <div class="ed_sert">
            <div class="gh_yy" *ngFor="let item of businessTypeData; let i = index">
            <mat-radio-button name="shop_type" [checked]="item.isSelected ==  1" [value]="item.value" (click)="changeBusinessType($event,i)">{{item.title}}</mat-radio-button>
          </div>
          <!-- <div class="gh_yy">
            <mat-radio-button value="2">Individual professional</mat-radio-button>
            </div> -->
        </div>
          </mat-radio-group>          
    <!-- </mat-form-field> -->
</div>
    <div class="ad_hesig" *ngIf="businessTypeData[1].isSelected == 1">
    <label for="" class="gth_heding" >Gender of service provider</label>
    <!-- <mat-form-field appearance="outline"> -->
        <mat-radio-group aria-label="Select an option">
            <div class="ed_sert">
            <div class="gh_yy" *ngFor="let item of professsionalGender; let i = index">
            <mat-radio-button name="provider_gender" [checked]="item.isSelected ==  1" [value]="item.name" (click)="selectProfessionalGender(i)">{{item.title}}</mat-radio-button>
          </div>
          <!-- <div class="gh_yy">
            <mat-radio-button value="2">Individual professional</mat-radio-button>
            </div> -->
        </div>
          </mat-radio-group>          
    <!-- </mat-form-field> -->
</div>


<div class="fft_section">
<label for="" class="gth_heding">Type of service</label>
    <div class="edit_serv">
    <div class="ser_tt" *ngFor="let item of toShowServiceTemplates; let i= index">
      
        <mat-checkbox [disabled]="checkDisabilityForCheckBox(item)" [value]="item" (change)="selectServiceTemplate($event,i)" [checked]="item.isSelected"></mat-checkbox>
          <mat-label class="label_t" [ngStyle]="{'color': checkDisabilityForCheckBox(item) ? '#868484' : '#212121'}">{{item.name}}</mat-label>
     </div>
     
    </div>
</div>

<label for="" class="gth_heding">Service offering mode</label>
    <div class="edit_serv">
        <div class="ser_tt" *ngFor="let item of serviceTypeData; let i = index">
            <mat-checkbox [value]="item" (change)="selectServiceTypeData($event,i)" [checked]="item.isSelected"></mat-checkbox>
              <mat-label class="label_t">{{item.title}}</mat-label>
         </div>
         
         </div>



         <div class="ad_hesig">
            <label for="" class="gth_heding" >Target customer type</label>
            <!-- <mat-form-field appearance="outline"> -->
                <mat-radio-group aria-label="Select an option">
                    <div class="ed_sert">
                    <div class="gh_yy" *ngFor="let item of serviceTypeGender; let i = index">
                    <mat-radio-button name="service_gender" [checked]="item.isSelected ==  1" [value]="item.id" (click)="selectServiceTypeGender(i)">{{item.title}}</mat-radio-button>
                  </div>
                </div>
                  </mat-radio-group>          
            <!-- </mat-form-field> -->
        </div>

    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Cancel</button>
        <button
        (click)="onSave()"
        [disabled]="checkServicesSelected() || isGenderSelected() || checkServiceTypeSelected() || checkServiceTargetTypeSelected()"
          mat-flat-button
          color="accent">
        Save
        </button>
      </mat-dialog-actions>
</div>
